export default "__VITE_ASSET__Dxt$tcQh__"